export enum UserAction {
    INSERT,
    EDIT
}
